import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M892.8 448.2H576.3V131.6c0-35.2-28.8-63.9-63.9-63.9-35.2 0-63.9 28.8-63.9 63.9v316.6H131.8c-35.2 0-63.9 28.8-63.9 63.9 0 35.2 28.8 63.9 63.9 63.9h316.6v316.6c0 35.2 28.8 63.9 63.9 63.9 35.2 0 63.9-28.8 63.9-63.9V576h316.6c35.2 0 63.9-28.8 63.9-63.9 0.1-35.1-28.7-63.9-63.9-63.9z\" p-id=\"9023\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol